<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Tickets
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: auto;width: 80px;border-radius:5px')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Tickets

    v-tabs(v-model='tab' color='#fe0100' background-color='white' style='margin-top:8px;')
      v-tab Tickets por Fecha
      v-tab Clientes con Tickets

    v-tabs-items(v-model='tab')

      //── Pestaña 1: Tickets por fecha ─────────────────────────────────────────
      v-tab-item
        v-layout(align-start='' justify-start='' row='' wrap='' fill-height='')
          v-flex(xs6 style='margin-top:5px;display:flex;')
            v-menu(ref='menu1' v-model='modal' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='450px' min-width='450px')
              template(v-slot:activator='{ on, attrs }')
                v-text-field(v-model='dateFormatted' label='Fecha' style='padding-left:15px;' persistent-hint='' v-bind='attrs' @blur='date = parseDate(dateFormatted)' v-on='on')
              v-date-picker(v-model='date' no-title='' @input='modal = false' dark='')
            v-btn.mx-0(icon='' @click='buscar' style='background:white;border-radius:100%;margin-left:10px !important;').elevation-4
              v-icon(color='#fe0100' style='font-size:1.70rem;') search
          v-flex(xs6 style='margin-top:5px;display:flex;justify-content:flex-end;align-items:center;gap:8px;')
            v-progress-circular(v-if='loading' indeterminate='' color='primary')
            v-btn(small='' color='#c70000' dark='' @click='generarDelDia' :loading='loadingGenerar')
              v-icon(left='' small='') confirmation_number
              | Generar del Día
            vue-excel-xlsx(v-if='resultados2 && resultados2.length > 0' :data='dataExcel' :columns='columnsExcel' :file-name="'Emanuel-Tickets'" :sheet-name="'Tickets'")
              img(src='../assets/iconos/excel.png' style='height:50px;width:auto;cursor:pointer;')
          v-flex(xs12 style='margin-top:5px;')
            v-card(style='border-radius:0 0 20px 20px;background-color:black;')
              v-card-title(style='padding:7px;').justify-center
                span.white--text Lista de Tickets — {{ dateFormatted }}
            v-data-table.elevation-1(:headers='headers' :items='resultados' style='margin-top:5px;')
              template(slot='items' slot-scope='props')
                td {{ props.item.fecha ? $moment(props.item.fecha).format('DD/MM/YYYY') : '--' }}
                td {{ props.item.nro || '--' }}
                td {{ props.item.doc_num || '--' }}
                td {{ props.item.cliente || '--' }}
                td {{ props.item.vendedor || '--' }}
                td
                  v-chip(:color="props.item.estatus === 'Pendiente' ? 'green' : props.item.estatus === 'Anulado' ? 'red' : 'grey'" text-color='white' small='') {{ props.item.estatus || '--' }}

      //── Pestaña 2: Clientes con tickets ──────────────────────────────────────
      v-tab-item
        v-layout(align-start='' justify-start='' row='' wrap='' fill-height='')
          v-flex(xs12 style='margin-top:8px;display:flex;justify-content:space-between;align-items:center;padding:0 8px;')
            v-text-field(v-model='searchCliente' label='Buscar cliente...' prepend-icon='search' clearable='' style='max-width:320px;')
            v-btn(small='' color='#fe0100' dark='' @click='cargarClientes' :loading='loadingClientes')
              v-icon(left='' small='') refresh
              | Actualizar
            vue-excel-xlsx(v-if='resumenClientes.length > 0' :data='dataExcelClientes' :columns='columnsExcelClientes' :file-name="'Emanuel-Clientes-Tickets'" :sheet-name="'Clientes'")
              v-btn(small='' color='green' dark='' style='margin-left:8px;')
                v-icon(left='' small='') cloud_download
                | Excel
          v-flex(xs12 style='margin-top:5px;')
            v-card(style='border-radius:0 0 20px 20px;background-color:black;')
              v-card-title(style='padding:7px;').justify-center
                span.white--text Clientes con Tickets Generados
            v-data-table.elevation-1(:headers='headersClientes' :items='resumenClientesFiltrados' style='margin-top:5px;' :loading='loadingClientes')
              template(slot='items' slot-scope='props')
                td {{ props.item.co_cli }}
                td {{ props.item.cliente }}
                td {{ props.item.vendedor }}
                td(style='text-align:center;font-weight:bold;') {{ props.item.total }}
                td(style='text-align:center;')
                  v-chip(color='green' text-color='white' small='') {{ props.item.pendientes }}
                td(style='text-align:center;')
                  v-icon(v-if='props.item.email' color='green') check_circle
                  v-icon(v-else color='grey') cancel
                td
                  span(v-if='props.item.email' style='font-size:12px;') {{ props.item.email }}
                  span(v-else style='color:#aaa;font-size:12px;') Sin email
                td(style='text-align:center;')
                  v-chip(v-if='props.item.tieneCredenciales' color='blue' text-color='white' small='') Tiene acceso
                  v-chip(v-else color='orange' text-color='white' small='') Sin credenciales

  //── Modal Espera ──────────────────────────────────────────────────────────────
  v-dialog(v-model='dialog4' persistent='' max-width='400px' style='background:#f1f2f1')
    v-container(style='max-width: 400px;background:#f1f2f1')
      div(style="margin-top: 20px;")
          v-flex(xs12 sm12)
            v-layout(align-start='' justify-center='' row='' wrap='' fill-height='')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h4.black--text  Esperando Respuesta del Servidor.!!
              v-flex(xs12)
                  div(style='display: flex;justify-content: center;').text-xs-center
                    img(src='../assets/waiting.gif' with='200' height='150')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h5.black--text  Por favor espere...
</template>

<script>
import Api from "@/services/methods";
import { serverImg } from "@/services/environment";
export default {
  name: "Tickets",
  data: vm => ({
    ruta: serverImg,
    tab: 0,
    resultados: [],
    resultados2: [],
    modal: false,
    dialog4: false,
    loading: true,
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    dataExcel: [],
    columnsExcel: [
      { label: "Fecha",    field: "fecha" },
      { label: "Nro",      field: "nro" },
      { label: "Pedido",   field: "doc_num" },
      { label: "Cliente",  field: "cliente" },
      { label: "Vendedor", field: "vendedor" },
      { label: "Estatus",  field: "estatus" }
    ],
    headers: [
      { text: "Fecha",    value: "fecha" },
      { text: "Nro",      value: "nro" },
      { text: "Pedido",   value: "doc_num" },
      { text: "Cliente",  value: "cliente" },
      { text: "Vendedor", value: "vendedor" },
      { text: "Estatus",  value: "estatus" }
    ],
    // Pestaña clientes
    resumenClientes: [],
    loadingClientes: false,
    searchCliente: '',
    headersClientes: [
      { text: "Código",        value: "co_cli" },
      { text: "Cliente",       value: "cliente" },
      { text: "Vendedor",      value: "vendedor" },
      { text: "Total tickets", value: "total",     sortable: true },
      { text: "Pendientes",    value: "pendientes", sortable: true },
      { text: "Email",         value: "email" },
      { text: "Correo",        value: "email_val" },
      { text: "Credenciales",  value: "tieneCredenciales" }
    ],
    columnsExcelClientes: [
      { label: "Código",        field: "co_cli" },
      { label: "Cliente",       field: "cliente" },
      { label: "Vendedor",      field: "vendedor" },
      { label: "Total Tickets", field: "total" },
      { label: "Pendientes",    field: "pendientes" },
      { label: "Email",         field: "email" },
      { label: "Tiene Acceso",  field: "credencialesLabel" }
    ],
    cre: "",
    mod: "",
    elm: "",
    loadingGenerar: false
  }),
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    resumenClientesFiltrados () {
      if (!this.searchCliente) return this.resumenClientes
      const q = this.searchCliente.toLowerCase()
      return this.resumenClientes.filter(c =>
        (c.cliente || '').toLowerCase().includes(q) ||
        (c.co_cli  || '').toLowerCase().includes(q) ||
        (c.email   || '').toLowerCase().includes(q)
      )
    },
    dataExcelClientes () {
      return this.resumenClientes.map(c => ({
        ...c,
        credencialesLabel: c.tieneCredenciales ? 'Sí' : 'No'
      }))
    }
  },
  watch: {
    date () {
      this.dateFormatted = this.formatDate(this.date)
    },
    tab (val) {
      if (val === 1 && this.resumenClientes.length === 0) {
        this.cargarClientes()
      }
    }
  },
  created() {
    this.verificacion();
    this.initialize();
  },
  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    verificacion() {
      for (let i = 0; i < this.$store.state.adminemanuel.permisos.length; i++) {
        if (this.$store.state.adminemanuel.permisos[i].ruta === "Tickets") {
          for (let j = 0; j < this.$store.state.adminemanuel.permisos[i].accion.length; j++) {
            if (this.$store.state.adminemanuel.permisos[i].accion[j] === "Crear")    this.cre = "yes"
            if (this.$store.state.adminemanuel.permisos[i].accion[j] === "Modificar") this.mod = "yes"
            if (this.$store.state.adminemanuel.permisos[i].accion[j] === "Eliminar") this.elm = "yes"
          }
        }
      }
    },
    initialize() {
      this.date = new Date().toISOString().substr(0, 10)
      this.dateFormatted = this.formatDate(new Date().toISOString().substr(0, 10))
      this.buscar()
    },
    buscar() {
      this.loading = true
      this.dialog4 = true
      this.dataExcel = []
      Api.get("tickets?fecha=" + this.date).then(res => {
        this.resultados = res.data
        this.dialog4 = false
      }).catch(err => {
        console.log(err)
        this.$swal.fire("¡Atención!", "Error de conexión, intente nuevamente.", "error")
        this.dialog4 = false
      })
      Api.get("tickets/all").then(res => {
        this.resultados2 = res.data
        for (const el of this.resultados2) {
          this.dataExcel.push({
            fecha:    this.$moment(el.fecha).format('DD-MM-YYYY H:mm A'),
            nro:      el.nro,
            doc_num:  el.doc_num,
            cliente:  el.cliente,
            vendedor: el.vendedor,
            estatus:  el.estatus
          })
        }
        this.loading = false
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    cargarClientes() {
      this.loadingClientes = true
      Api.get("tickets/clientes/resumen").then(res => {
        this.resumenClientes = res.data
        this.loadingClientes = false
      }).catch(err => {
        console.log(err)
        this.loadingClientes = false
      })
    },
    generarDelDia() {
      this.loadingGenerar = true
      Api.post("tickets/generar-del-dia?fecha=" + this.date, {}).then(res => {
        this.loadingGenerar = false
        const d = res.data
        this.$swal.fire(
          'Tickets generados',
          `Pedidos procesados: ${d.pedidosProcesados} — Tickets creados: ${d.generados}`,
          d.generados > 0 ? 'success' : 'info'
        )
        this.buscar()
      }).catch(err => {
        console.log(err)
        this.loadingGenerar = false
        this.$swal.fire('Error', 'No se pudo generar los tickets.', 'error')
      })
    }
  }
};
</script>
<style lang="scss">
@media only screen and (max-width: 600px) {
  .wdd {
    width: 200px !important;
  }
}
.cll {
  .v-messages.theme--light {
    display: none !important;
  }
}
</style>
